module.exports = __webpack_public_path__ + "static/about_bg-7c9a7bc923f9c9b6c8fec7ecdd8d130c.svg";